module.exports = __webpack_public_path__ + "static/media/Evans.77682e78.jpeg";